// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MPdZ","textarea":"styles_textarea__1r1nt"};